import React from 'react';
import t from '~t';
import { compact } from '~modules/format/number';

import {
  Item,
  ItemTitle,
  ItemInfo,
  ItemActions,
  Button,
  cn,
} from '~ui';
import { Icon, SuperLink } from '~ui';
import TagIcon from './icon';

export default function TagsItemView({
  active,
  item: { _id, count, isNew, query },
  showIcon = true,
  focusable,
  onRenameClick,
  oneRename,
  onRenameCancel,
  onContextMenuClose,
  onRemoveClick,
  onRename,
  oneRemove, //to ignore
  className,
  ...etc
}) {
  return (
    <Item
      onDoubleClick={onRenameClick}
      {...etc}
      className={cn('cursor-pointer', className)}
      active={active}
    >
      {showIcon && <TagIcon />}

      <ItemTitle>{_id}</ItemTitle>

      {count ? <ItemInfo>{compact(count)}</ItemInfo> : null}
      {isNew ? <ItemInfo>{t.s('newTag')}</ItemInfo> : null}
      <ItemActions>
        {etc.onContextMenu && (
          <Button
            variant='ghost'
            size='icon'
            title={t.s('more')}
            onClick={etc.onContextMenu}
          >
            <Icon name='more_horizontal' />
          </Button>
        )}
      </ItemActions>

      {focusable && (
        <SuperLink
          to={`/my/0/${encodeURIComponent(query.trim())}`}
          tabIndex='0'
        />
      )}
    </Item>
  );
}
